import React from "react"
import Obfuscate from "react-obfuscate"

import styles from "./ContactEmail.module.scss"

const ContactEmail = ({ align = "left", icon = true, children }) => {
  const camelCase = require("camelcase")
  return (
    <div className={`${styles.item} ${styles[camelCase(align)]}`}>
      {icon && <img src={"/media/svg/email.svg"} alt="" aria-hidden="true" />}
      <div>
        <Obfuscate element="span" email={children} />
      </div>
    </div>
  )
}

export default ContactEmail
